export enum Subjects {
	ClientSpaceConfig = 'ClientSpaceConfig',
	ProjectSpaceConfig = 'ProjectSpaceConfig',
	IntegrationConfig = 'IntegrationConfig',
	FlowConfig = 'FlowConfig',
	MicroTaskConfig = 'MicroTaskConfig',
	RoleConfig = 'RoleConfig',
	UserConfig = 'UserConfig',
	VariableConfig = 'VariableConfig',
	BuildInfo = 'BuildInfo',
	DeliveryResponse = 'DeliveryResponse',
	ExecutionHistory = 'ExecutionHistory',
	ExpressionPayload = 'ExpressionPayload',
	ApiKeyConfig = 'ApiKeyConfig',
	ArchiveConfig = 'ArchiveConfig',
	Simulation = 'Simulation',
	DBBackupConfig = 'DBBackupConfig',
	SecretConfig = 'SecretConfig', //Actually hits the variable service via the secrets controller, but keeping the subject for security granularity
	WhitelistIpConfig = 'WhitelistIpConfig',
	PasswordReset = 'PasswordReset',
	UserProfile = 'UserProfile',
	DbMigration = 'DbMigration',
	TenantConfig = 'TenantConfig',
	ImportExportConfig = 'ImportExportConfig',
	PasswordSettings = 'PasswordSettings',
	RagAi = 'RagAi',
	EmailTemplateConfig = 'EmailTemplateConfig',
	UniqueHistoryConfig = 'UniqueHistoryConfig',
	DashboardConfig = 'DashboardConfig',
	AIAssistantConfig = 'AIAssistantConfig',
	XeroConnectionConfig = 'XeroConnectionConfig',
	HubSpotConnectionConfig = 'HubSpotConnectionConfig',
}
